import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject, Input, DestroyRef, inject } from '@angular/core';
import { LoginService } from '../../../core/services/login.service';
import { SessionStorageService } from '../../../core/services/session-storage.service';
import { UtilsService } from '../../../core/services/utils';
import { OpenidProviderComponent } from '../openid-provider/openid-provider.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'google-signin',
    templateUrl: './google-signin.component.html',
    styleUrls: ['./google-signin.component.scss'],
    standalone: true
})
export class GoogleSigninComponent extends OpenidProviderComponent implements AfterViewInit {
  private readonly googleLogin = '{issuer}?client_id={clientId}&response_type=id_token token&redirect_uri={redirectUri}&state={state}&scope={scope}&nonce={hydraNonce}';
  private readonly google = 'google';
  @Input()
  private challenge: string;
  private redirectUrl: string;
  private destroyRef = inject(DestroyRef);

  constructor(@Inject(DOCUMENT) private document: any,
              private loginService: LoginService,
              private sessionStorageService: SessionStorageService,
              private utils: UtilsService) {
    super();
    this.openIdSettingsErrorSubscriber = this.openIdSettingsSubscriber.bind(this);
    this.openIdSettingsSubscriber = this.openIdSettingsSubscriber.bind(this);
  }

  public ngAfterViewInit() {
    this.loginService.getOAuthSettings(this.challenge, this.google)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(this.openIdSettingsSubscriber, this.openIdSettingsErrorSubscriber);
  }

  public googleSigin() {
    this.document.location.href = this.redirectUrl;
  }

  private openIdSettingsSubscriber(res) {
    const {issuer, clientId, redirectUri, scope} = res;
    const hydraNonce = this.sessionStorageService.value('nonce');
    const customParams = {'nonce': hydraNonce, 'challenge': this.challenge, 'provider': this.google};
    const state = super.encodeCustomParams(customParams);
    const url = this.utils.parseTemplateString(this.googleLogin, {
      issuer, clientId, redirectUri, state, scope, hydraNonce
    });
    this.redirectUrl = url;
  }

  private openIdSettingsErrorSubscriber(err) {
    const msg = super.getErrorMsg(err);
    console.log(msg);
  }
}
